module.exports = __webpack_public_path__ + "static/media/ecology.cea98a85.svg";